import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormHelperText, } from '@mui/material';
const CheckboxFormItem = (props, ref) => {
    const { label, labelPlacement = 'end', hasLongLabelText, errorMessage, ...cmpProps } = props;
    const id = React.useId();
    const isError = !!errorMessage;
    return (_jsxs(FormControl, { sx: { '& .MuiFormControlLabel-asterisk': { display: 'none' } }, children: [_jsx(FormControlLabel, { control: _jsx(Checkbox, { sx: {
                        ...(hasLongLabelText && { alignSelf: 'flex-start' }),
                    }, inputProps: {
                        'aria-describedby': id,
                        'aria-invalid': isError,
                        ...(cmpProps.inputProps ?? {}),
                    }, ref: ref, ...cmpProps }), label: label, labelPlacement: labelPlacement }), _jsx(FormHelperText, { id: id, error: isError, children: errorMessage })] }));
};
export default React.forwardRef(CheckboxFormItem);
